import { observer } from 'mobx-react-lite';
import queryString from 'query-string';
import React, { Fragment, useContext, useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Divider, Grid, Header, Icon, Image, Message, Segment } from 'semantic-ui-react';

import { PROCESS_STATE } from '../../../app/common/util/util';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import { IReservation } from '../../../app/models/reservation';
import { RootStoreContext } from '../../../app/stores/rootStore';
import Information from './Information';
import ReservationDetails from './ReservationDetails';
import ReservationFilters from './ReservationFilters';
import ReservationList from './ReservationList';

const ReservationDashboard: React.FC<RouteComponentProps> = ({ location }) => {
  const rootStore = useContext(RootStoreContext);
  const {
    loading,
    loading2,
    reservation,
    schedules,
    sysdate,
    reservationPeriod,
    loadReservation,
    getSysDate,
  } = rootStore.reservationStore;
  const { information, loadInformation } = rootStore.informationStore;
  const { qr } = queryString.parse(location.search);

  useEffect(() => {
    getSysDate();
    loadInformation();
    loadReservation(qr as string);
  }, [qr, loadReservation, loadInformation, getSysDate]);

  const isReservation = (reservation: IReservation) => {
    // 判定
    if (reservationPeriod < reservation.startDate!) {
      // 予約可能期間（90日先） < 入場意向日
      return false;
    }
    if (reservation.limitMonthDate! < sysdate!) {
      // 有効期限日 < SYSDATE
      return false;
    }
    return true;
  };

  if (loading) return <LoadingComponent content="Loading..." />;

  return (
    <Fragment>
      <Segment inverted vertical>
        <Header textAlign="center">
          <Image src="/assets/logo_tour_gold.svg" alt="logo" />
        </Header>
      </Segment>
      <Header as="h3" textAlign="center">
        トップデッキツアー予約画面
      </Header>
      <Grid textAlign="center">
        <Grid.Column style={{ maxWidth: 300 }} textAlign="left">
          {information.length > 0 && <Information />}
          {reservation && reservation.deleteFlagEnum === PROCESS_STATE.Done ? (
            <Segment>
              <Message negative>
                <Icon name="exclamation" />
                使用不可
              </Message>
            </Segment>
          ) : reservation && !isReservation(reservation) ? (
            <Segment>
              <Message negative>
                <Icon name="exclamation" />
                予約可能期間外
              </Message>
            </Segment>
          ) : reservation && reservation.reservationDate !== null ? (
            <Fragment>
              <Message positive>
                <Icon name="info" />
                ご予約が完了しました。当日はQR付きの紙チケットをお持ちいただき、スタッフにご提示ください。
              </Message>
              <ReservationDetails />
            </Fragment>
          ) : (
            <Fragment>
              <ReservationFilters />
              {loading2 ? <LoadingComponent content="Loading..." /> : schedules.length > 0 && <ReservationList />}
            </Fragment>
          )}
        </Grid.Column>
      </Grid>
      <Divider inverted section />
      <Header as="h6" textAlign="center">
        © TOKYO TOWER. All rights reserved.
        <br />
      </Header>
    </Fragment>
  );
};

export default observer(ReservationDashboard);
